import React, { Fragment, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import CloseIcon from '@mui/icons-material/Close';
import { OBSERVATION_TYPE } from '../../../../AppraiserForm/constants/observationType';
import DataRow from './DataRow';
import { AdditionalInformationSection } from './AdditionalInformationSection';
import { OBSERVATION_OPTIONS } from '../../../../AppraiserForm/constants/observationOptions';
import styles from './ProfilePopover.module.scss';

/**
 * @typedef {object} ProfilePopoverProps
 * @property {string} [name]
 * @property {Object} [appraiserData]
 * @property {boolean} [disabled]
 */

/**
 * @param {ProfilePopoverProps} props
 */
const ProfilePopover = props => {
  const { name, appraiserData = {}, disabled = false } = props;

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <button className='profile-popover-link' onClick={handleClick} disabled={disabled}>
        Profile
      </button>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='sm'
        fullWidth
        slotProps={{ backdrop: { invisible: true } }}
        aria-labelledby='profile-popover-title'
        className={styles.dialog}>
        <div className={styles.card} data-testid='profile-popover'>
          <div className={styles.header}>
            <div>
              <h3 id='profile-popover-title' className={styles.title}>
                {name}
              </h3>
              {appraiserData.observation !== OBSERVATION_TYPE.NA && (
                <span className={styles.subtitle} data-testid='profile-popover-subtitle'>
                  {OBSERVATION_OPTIONS[appraiserData.observation]}
                </span>
              )}
            </div>
            <IconButton
              className={styles.close}
              size='small'
              aria-label='Close'
              onClick={handleClose}>
              <CloseIcon fontSize='small' />
            </IconButton>
          </div>
          <Divider />
          <section className={styles.section}>
            <h4 className={styles.sectionTitle}>Location and domain</h4>
            <DataRow title='Time Zone' description={appraiserData.timeZone} />
            <Divider />
            <DataRow title='State' description={appraiserData.state} />
            <Divider />
            <DataRow title='Country' description={appraiserData.country} />
            {appraiserData.domainExperienceSummaryList?.map(domainExperience => (
              <Fragment key={`${appraiserData.externalUserId}${domainExperience.domain}`}>
                <Divider />
                <DataRow
                  title='Domain'
                  description={getDomainExperienceDescription(domainExperience)}
                />
              </Fragment>
            ))}
          </section>
          {appraiserData.additionalInformation && (
            <>
              <Divider />
              <AdditionalInformationSection
                additionalInformation={appraiserData.additionalInformation}
              />
            </>
          )}
        </div>
      </Dialog>
    </div>
  );
};

const getDomainExperienceDescription = domainExperience =>
  `${domainExperience.domain} ${domainExperience.highestRole} ${domainExperience.totalYearsOfExperience}yr.`;

export default ProfilePopover;
